export enum UdpFormsFieldTypeEnum {
    Hidden = 1,
    SingleLineText = 2,
    MultiLineText = 3,
    Checkbox = 4,
    RadioButton = 5,
    DropdownSingleSelect = 6,
    DropdownMultipleSelect = 7,
    ListMultiSelect = 8,
    DateSelector = 9,
    TimeSelector = 10,
    DateTimeSelector = 11,
    FileUpload = 12,
    Paragraph = 13
  }
  